module.exports = __webpack_public_path__ + "img/user-default-400.png";